<template>
  <div>
    <!-- 追加 -->
    <div class="form-group">
      <el-button
        v-bind:icon="iconData"
        plain
        class="glance"
        size="small"
        @click="onClick"
        :class="useFul ? 'disbale_div' : 'able_div'"
      >

      </el-button>
      <div class="button_title">テナントを追加する</div>
    </div>

  </div>
</template>
<script>
export default {
  methods: {
    onClick(event) {
      if (this.useFul) {
        return;
      }
      if (this.$listeners.click) {
        this.$listeners.click();
        event.stopPropagation();
      }
    },
  },
  props: {
    // el-icon-circle-plus
    iconData: String,
    useFul: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.glance {
  border: 0px;
  text-align: left;
  padding: 0;
  border-radius: 50% !important;
  color: #329ca6;
  background-color: transparent;
  font-weight: bold;
  width: 18px;
  height: 18px;
  margin-top: -5px;
  font-size: 14px;
  box-shadow: -2px -2px 5px #FCFCFB,
               5px  5px 8px #C6C6BC;
  display: flex;
}
.glance:hover {
  opacity: 0.6;
}
.glance:focus {
  color: #329ca6;
  background-color: transparent;
}
// 設定icon大小
::v-deep .el-icon-circle-plus:before {
  font-size: 23px;
}
::v-deep .el-icon-remove:before {
  font-size: 23px;
}
.button_title {
  color: #525250;
  margin-left: 12px;
  font-weight: normal;
}
.able_div {
}
.disbale_div {
  cursor: not-allowed;
}
</style>
